import axios from "../plugins/parseAxios";
export class PenaltySettingAPI {
  static getPenaltySettingByMarket(payload) {
    return axios.post("functions/getPenaltySettingByMarket", payload);
  }
  static createPenaltySetting(payload) {
    return axios.post("functions/createPenaltySetting", payload);
  }
  static updatePenaltySetting(payload) {
    return axios.post("functions/updatePenaltySetting", payload);
  }
}